import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Stethoscope, FileSearch, PhoneCall, ActivitySquare, HeartPulse, ArrowRight } from 'lucide-react';
const services = [{
  title: 'A+ Ancillary Services',
  description: 'Our newest offering — one integrated source for physical therapy, diagnostics, DME, transportation, and more.',
  icon: ActivitySquare,
  to: '/services/ancillary',
  featured: true
}, {
  title: 'Medical Triage Nurse',
  description: '24/7 telephonic nurse triage at the moment of injury — the right care from minute one.',
  icon: HeartPulse,
  to: '/services/triage',
  featured: false
}, {
  title: 'Case Management',
  description: 'Experienced nurse case managers coordinate care, remove barriers, and accelerate return to work.',
  icon: PhoneCall,
  to: '/services/case-management',
  featured: false
}, {
  title: 'Medical Bill Review',
  description: 'AI-assisted technology and clinical expertise ensure accurate pricing, compliance, and maximum savings.',
  icon: FileSearch,
  to: '/services/bill-review',
  featured: false
}, {
  title: 'Utilization Review',
  description: 'URAC-accredited, evidence-based medical necessity determinations across all 50 states.',
  icon: Stethoscope,
  to: '/services/utilization-review',
  featured: false
}];
export function Services() {
  return <section id="services" className="py-24 bg-brand-paper" data-id="element-314">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-315">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-316">
          <h2 className="text-brand-gold font-semibold tracking-wider uppercase text-sm mb-3" data-id="element-317">
            Our Expertise
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-brand-navy mb-6" data-id="element-318">
            A complete managed care toolkit
          </h3>
          <p className="text-lg text-gray-600" data-id="element-319">
            We provide customized programs and a personal connection to handle
            the complex challenges of medical management — from first injury to
            final settlement.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-320">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className={`group relative bg-white rounded-xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 overflow-hidden flex flex-col ${service.featured ? 'ring-2 ring-brand-gold/50' : ''}`} data-id="element-321">
                <div className="absolute top-0 left-0 w-full h-1 bg-brand-gold transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" data-id="element-322"></div>

                {service.featured && <div className="absolute top-4 right-4 bg-brand-gold/10 text-brand-gold text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-323">
                    Featured
                  </div>}

                <div className={`w-14 h-14 rounded-lg flex items-center justify-center mb-6 transition-colors duration-300 ${service.featured ? 'bg-brand-gold text-white' : 'bg-brand-navy/5 text-brand-navy group-hover:bg-brand-navy group-hover:text-white'}`} data-id="element-324">
                  <Icon className="w-7 h-7" data-id="element-325" />
                </div>

                <h4 className="text-xl font-serif font-bold text-brand-navy mb-3" data-id="element-326">
                  {service.title}
                </h4>
                <p className="text-gray-600 mb-6 leading-relaxed text-sm flex-grow" data-id="element-327">
                  {service.description}
                </p>

                <Link to={service.to} className="inline-flex items-center text-brand-navy font-semibold text-sm group-hover:text-brand-gold transition-colors mt-auto" data-id="element-328">
                  Learn more
                  <ArrowRight className="w-4 h-4 ml-1 transform group-hover:translate-x-1 transition-transform" data-id="element-329" />
                </Link>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}